import {
  BellOutlined,
  InfoCircleOutlined,
  LineChartOutlined,
  MessageOutlined,
  PieChartOutlined,
  SearchOutlined,
  SettingOutlined,
  ThunderboltOutlined,
  UserOutlined,
  LockOutlined,
  RobotOutlined,
} from "@ant-design/icons";
import { Layout, Menu, Space, Spin } from "antd";
import Launcher from "commandbar-launcher";
import React, { useEffect, useState, useContext } from "react";
import {
  Link,
  Route,
  Routes,
  useNavigate,
  Navigate,
  useHref,
} from "react-router-dom";
import { checkAccess } from "../lib/admin";
import {
  DiscordChannelsProvider,
  SlackChannelsProvider,
} from "../components/ChannelContext/ChannelContext";
import { GlobalModalContext } from "../components/GlobalModalContext/GlobalModalContext";
import ChannelDetail from "../components/ChannelDetail/ChannelDetail";
import CompanyDetails from "../components/Companies/CompanyDetails";
import { DateProvider } from "../components/DateContext/DateContext";
import DiscordTriggers from "../components/DiscordTriggers/DiscordTriggers";
import GithubAdded from "../components/GithubAdded/GithubAdded";
import DotsHeader from "../components/DotsHeader/DotsHeader";
import Insights from "../components/InsightsPage/Insights.tsx";
import Members from "../components/Members/Members";
import Messages from "../components/Messages/Messages";
import NotionOAuth from "../components/NotionOAuth/NotionOAuth";
import Overall from "../components/Overall/Overall";
import SelectTeams from "../components/SelectTeams/SelectTeams";
import Settings from "../components/Settings/Settings";
import { TagsProvider } from "../components/TagsContext/TagsContext";
import Triggers from "../components/Triggers/Triggers";
import { getChannels, getDiscordChannels } from "../lib/queries";
import { getSupaClient } from "../lib/supabase";
import DiscordHome from "./DiscordHome.tsx";

import { DiscordMemberModal, SlackMemberModal } from "../lib/memberModal";
import NotFound from "../components/NotFound/NotFound";
import DiscordMessages from "../components/DiscordMessages/DiscordMessages";
import Admin from "../components/Admin/Admin";
import { usePaywall } from "../components/Paywall/usePaywall";
import { PaywallProvider } from "../components/Paywall/PaywallContext";

const theme = {
  icon: { borderColor: "#dcdcdc", width: "17px" },
  unseenBadge: { backgroundColor: "#768a02" },
  header: {
    backgroundColor: "#cdb6e7",
    textColor: "#ffffff",
    borderRadius: "16px",
  },
  footer: {
    backgroundColor: "#cdb6e7",
    textColor: "#ffffff",
    borderRadius: "16px",
  },
  notification: {
    default: {
      textColor: "#15091F",
      borderRadius: "8px",
      backgroundColor: "#cdb6e7",
    },
    unseen: {
      backgroundColor: "#cdb6e7",
      textColor: "#15091F",
      borderRadius: "8px",
    },
    unread: {
      backgroundColor: "#cdb6e7",
      textColor: "#15091F",
      borderRadius: "10px",
    },
  },
};

const { Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const slackId = localStorage.getItem("slack-id");

function WhatsNew(props) {
  useEffect(() => {
    // window.Olvy.init({
    //   organisation: "dotshq",
    //   target: "#olvy-trigger",
    //   type: "sidebar",
    //   view: {
    //     showSearch: true,
    //     compact: false,
    //     showHeader: true,
    //     showUnreadIndicator: true,
    //     unreadIndicatorColor: "#FFE3B887",
    //     unreadIndicatorPosition: "top-right",
    //   },
    // });
    // window.Olvy.setUser({
    //   team: localStorage.getItem("team-name"),
    //   id: localStorage.getItem("team-id"),
    // });
    // return function cleanup() {
    //   window.Olvy.teardown();
    // };
  });
  return (
    <div>
      <div id="olvy-whats-new" className="-mt-0.5">
        <div>
          <BellOutlined style={{ fontSize: 16 }} />
        </div>
      </div>
      {/* <BellOutlined id="olvy-trigger" /> */}
    </div>
  );
}

const Home = (props) => {
  const [collapsed, setCollapsed] = useState(false);
  const platform = localStorage.getItem("platform");
  const [channels, setChannels] = useState([]);
  const navigate = useNavigate();
  const { pathname } = props.location;
  const teamId = localStorage.getItem("team-id");
  const guildId = localStorage.getItem("guild-id");
  const guildName = localStorage.getItem("guild-name");
  const teamName = localStorage.getItem("team-name");
  const supabase = getSupaClient();
  const { globalModal, setGlobalModal } = useContext(GlobalModalContext);
  const { loadingPlanTier, userPlanTier, trialing } = usePaywall();
  const session = supabase.auth.session();

  // eslint-disable-next-line no-shadow
  const onCollapse = (collapsed) => {
    setCollapsed(collapsed);
  };

  const loadChannels = async () => {
    let data = [];
    if (platform === "slack") {
      data = await getChannels(teamId);
    } else if (platform === "discord") {
      data = await getDiscordChannels(guildId);
    }
    window.CommandBar.addRecords("channels", data);
    setChannels(data);
  };

  useEffect(() => {
    const user = supabase.auth.user();
    const slackLoadedCorrectly = teamId && slackId;
    const discordLoadedCorrectly = guildName && guildId && user;
    loadChannels();
    window.analytics.track("Home loaded");
    // load command bar
    if (slackLoadedCorrectly) {
      /**
       * Adds a function to commandbar that can load members into the commandbar based
       * on a search, and paginates them using infinite scrolling.
       */
      window.CommandBar.addRecords("members", [], {
        onInputChange: async (query, pagination = 0) => {
          if (pagination === -1) return null;
          const { data, error } = await supabase
            .from("slack_users")
            .select("slack_id, name")
            .eq("team", teamId)
            .ilike("name", `%${query}%`)
            .neq("is_deleted", true)
            .order("joined_formatted_ts", { ascending: false })
            .range(pagination, pagination + 25);
          console.log(pagination);
          if (error) console.error(error);
          return {
            data: data,
            pagination: data.length > 0 ? pagination + 25 : -1,
          };
        },
        labelKey: "name",
      });
      window.CommandBar.addCallback("openMemberModal", ({ member }) => {
        setGlobalModal(<SlackMemberModal member={member} />);
      });
      window.CommandBar?.boot(`${teamName}-${slackId}`);
      window.CommandBar.addCallback("sendDm", () => {
        navigate({
          pathname: "/messages",
          state: {
            direct_message: true,
          },
        });
      });
      window.CommandBar.addCallback("goToChannel", ({ selected }) => {
        navigate(`/channel/${selected.slack_id}`);
      });
    }
    if (discordLoadedCorrectly) {
      /**
       * Adds a function to commandbar that can load members into the commandbar based
       * on a search, and paginates them using infinite scrolling.
       */
      window.CommandBar.addRecords("members", [], {
        onInputChange: async (query, pagination = 0) => {
          if (pagination === -1) return null;
          const queryWithDiscriminatorStripped = query.replace(
            /\b(#[0-9]{0,4})$/,
            ""
          );
          const discriminator = query.match(/\b(#[0-9]{0,4})$/);
          const supabaseQuery = supabase
            .from("discord_members")
            .select(
              `id,
           discriminator,
           username`
            )
            .eq("guild", guildId)
            .ilike("username", `%${queryWithDiscriminatorStripped}%`)
            .neq("is_deleted", true)
            .order("joined_at", { ascending: false })
            .range(pagination, pagination + 25);
          const supabaseQueryWithDiscriminator = discriminator
            ? supabaseQuery.ilike(
                "discriminator",
                `${discriminator[0].replace("#", "")}%`
              )
            : supabaseQuery;
          const { data, error } = await supabaseQueryWithDiscriminator;
          if (error) console.error(error);
          return { data, pagination: data.length > 0 ? pagination + 25 : -1 };
        },
      });
      window.CommandBar.addCallback("goToChannel", ({ selected }) => {
        navigate(`/insights?channel=${selected.discord_id}`);
      });
      window.CommandBar.addCallback("openMemberModal", async ({ member }) =>
        setGlobalModal(<DiscordMemberModal userId={member.id} />)
      );
      window.CommandBar?.boot(user.id, {
        guildName,
        guildId,
      });
    }
    if (slackLoadedCorrectly || discordLoadedCorrectly) {
      const routerFunc = (newUrl) => navigate(newUrl);
      window.CommandBar.addRouter(routerFunc);
    }
  }, []);

  const handleNotificationClick = (notification) => {
    if (notification.actionUrl) {
      navigate(notification.actionUrl);
      window.analytics.track("Notification clicked");
    }
  };

  const messagesPageComponent =
    platform === "slack" ? <Messages /> : <DiscordMessages />;

  return (
    // <Spin spinning={!channels.length>0}>
    <DiscordChannelsProvider>
      <SlackChannelsProvider>
        <DateProvider>
          <TagsProvider>
            <PaywallProvider
              loadingPlanTier={loadingPlanTier}
              userPlanTier={userPlanTier}
              trialing={trialing}
            >
              <Spin spinning={false}>
                {globalModal ? globalModal : null}
                <Layout
                  style={{
                    minHeight: "100vh",
                    overflowX: "hidden",
                    overFlowY: "hidden",
                  }}
                >
                  <Sider
                    style={{
                      backgroundColor: "#FFFFFF",
                      overflow: "hidden",
                      height: "100vh",
                      position: "fixed",
                      width: "100%",
                      borderRight: "solid #E8E8F1 1px",
                    }}
                    collapsible
                    collapsed={collapsed}
                    onCollapse={onCollapse}
                  >
                    <div className="dots-logo">
                      <div
                        style={
                          collapsed
                            ? {
                                display: "block",
                                marginLeft: "auto",
                                marginRight: "auto",
                                width: "50%",
                              }
                            : null
                        }
                      >
                        <Link to="/home">
                          <img
                            alt="link"
                            width={collapsed ? 27 : 39}
                            src="/logo-square.svg"
                          />
                        </Link>
                      </div>
                    </div>
                    {!collapsed ? (
                      <div className="team-name">
                        <div>
                          <SelectTeams isCollapsed={collapsed} />
                        </div>
                        <WhatsNew />
                      </div>
                    ) : null}
                    <div
                      style={{
                        width: "100%",
                        paddingRight: 16,
                        paddingLeft: 16,
                      }}
                    >
                      {!collapsed ? (
                        <Launcher
                          text={
                            <div style={{ color: "#16161D", paddingLeft: 8 }}>
                              Search
                            </div>
                          }
                          style={{
                            borderRadius: 10,
                            paddingRight: 10,
                            paddingLeft: 10,
                            border: "1px solid rgba(255,255,255,0.6)",
                            background: "#F5F7FA",
                          }}
                        />
                      ) : null}
                    </div>

                    <div style={{ padding: "10px 18px 20px 18px" }}>
                      {collapsed ? (
                        <div
                          style={{
                            width: 32,
                            height: 32,
                            borderRadius: 16,
                            backgroundColor: "#16161D",
                            color: "#FFFF",
                            margin: "auto",
                          }}
                        >
                          <SelectTeams isCollapsed={collapsed} />
                        </div>
                      ) : null}
                      {collapsed ? (
                        <div className="additional-menu-links">
                          <WhatsNew isCollapsed={collapsed} />
                        </div>
                      ) : null}
                      {collapsed ? (
                        <div
                          className="additional-menu-links"
                          onClick={() => window.CommandBar.open()}
                          onKeyDown={() => window.CommandBar.open()}
                          role="button"
                          tabIndex={0}
                        >
                          <SearchOutlined
                            style={{
                              fontSize: 16,
                            }}
                          />
                        </div>
                      ) : null}
                    </div>
                    <Menu
                      onClick={(e) => {
                        navigate(e.key);
                      }}
                      style={{
                        backgroundColor: "#FFFFFF",
                        paddingRight: 16,
                        paddingLeft: 16,
                        // trialling is considered here because on wide devices the menu is overlapped with trialing warning
                        marginTop: collapsed ? 0 : trialing ? 30 : 75,
                      }}
                      // theme="dark"
                      // defaultSelectedKeys={['1']}
                      mode="inline"
                      defaultOpenKeys={[]}
                      selectedKeys={[`/${pathname.split("/")[1]}`]}
                    >
                      <Menu.Item key="/home" icon={<PieChartOutlined />}>
                        Home
                      </Menu.Item>

                      <Menu.Item key="/messages" icon={<MessageOutlined />}>
                        Messages
                      </Menu.Item>

                      <Menu.Item
                        key="/automation"
                        icon={
                          platform === "slack" ? (
                            <ThunderboltOutlined />
                          ) : (
                            <RobotOutlined />
                          )
                        }
                      >
                        {platform === "slack" ? "Automation" : "Bots"}
                      </Menu.Item>

                      <Menu.Item key="/members" icon={<UserOutlined />}>
                        Members
                      </Menu.Item>
                      <Menu.Item key="/insights" icon={<LineChartOutlined />}>
                        Insights
                      </Menu.Item>

                      <Menu.Item key="/settings" icon={<SettingOutlined />}>
                        Settings
                      </Menu.Item>
                      {collapsed && trialing && (
                        <Menu.Item
                          key="/settings?tab=billing"
                          icon={<InfoCircleOutlined />}
                          style={{ background: "#F5F7FA", borderRadius: 10 }}
                        >
                          Trialling{" "}
                          {userPlanTier[0].toUpperCase() +
                            userPlanTier.slice(1)}{" "}
                          plan, click here to upgrade!
                        </Menu.Item>
                      )}
                      {checkAccess() && (
                        <Menu.Item key="/admin" icon={<LockOutlined />}>
                          Admin
                        </Menu.Item>
                      )}
                    </Menu>

                    {!collapsed && trialing && (
                      <div
                        className="border border-gray-300 text-center rounded-md w-4/5 text-xs font-medium cursor-pointer py-2"
                        style={{
                          position: "absolute",
                          bottom: "70px",
                          left: 20,
                        }}
                        onClick={() => {
                          navigate("/settings?tab=billing");
                        }}
                      >
                        <p className="mb-1">
                          Trialling{" "}
                          {userPlanTier[0].toUpperCase() +
                            userPlanTier.slice(1)}{" "}
                          plan
                        </p>
                        <p className="m-0 font-extrabold">
                          Click here to upgrade!
                        </p>
                      </div>
                    )}
                  </Sider>
                  <Layout
                    className="site-layout layout-full"
                    style={{
                      background: "#FFFFFF",
                      marginLeft: collapsed ? 80 : 200,
                    }}
                  >
                    <Content style={{ padding: "30px 40px" }}>
                      <DotsHeader />
                      <div>
                        <Routes>
                          <Route path="*" element={<NotFound />} />
                          <Route
                            exact
                            path="/"
                            element={<Navigate to="/home" replace="true" />}
                          />
                          <Route
                            exact
                            path="/home"
                            element={
                              platform === "slack" ? (
                                <Overall />
                              ) : (
                                <DiscordHome />
                              )
                            }
                          />
                          <Route
                            exact
                            path="/messages"
                            element={messagesPageComponent}
                          />
                          <Route exact path="/members" element={<Members />} />
                          <Route
                            exact
                            path="/settings"
                            element={<Settings />}
                          />
                          <Route
                            exact
                            path="/moderation"
                            element={messagesPageComponent}
                          />
                          <Route
                            exact
                            path="/triggers"
                            element={
                              platform === "slack" ? (
                                <Triggers />
                              ) : (
                                <DiscordTriggers />
                              )
                            }
                          />
                          <Route
                            path="/automation/*"
                            element={
                              platform === "slack" ? (
                                <Triggers />
                              ) : (
                                <DiscordTriggers />
                              )
                            }
                          />
                          <Route
                            exact
                            path="/auth/notion"
                            element={<NotionOAuth />}
                          />
                          <Route
                            path="/auth/github"
                            element={<GithubAdded />}
                          />
                          <Route
                            exact
                            path="/schedule"
                            element={messagesPageComponent}
                          />
                          <Route
                            path="/channel/:channelId"
                            element={<ChannelDetail />}
                          />
                          <Route
                            path="/insights/:companyId"
                            element={<CompanyDetails />}
                          />
                          <Route
                            exact
                            path="/insights"
                            element={<Insights />}
                          />
                          {checkAccess() && (
                            <Route exact path="/admin" element={<Admin />} />
                          )}
                          {/* <Route
                        exact
                        path="/editor"
                        element={DiscordEditorSandbox}
                      /> */}
                        </Routes>
                      </div>
                    </Content>
                    <Footer
                      style={{
                        background: "#FFFFFF",
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div>
                        Use chat,{" "}
                        <a href="https://discord.gg/WJFTPtvGGw"> discord</a>, or{" "}
                        <a href="mailto:hello@dots.community"> email </a> for
                        help!
                      </div>
                      {/* <CommandBar
                      trigger="Press Command + K for superpowers!"
                      channels={channels}
                    />{" "} */}
                    </Footer>
                  </Layout>
                </Layout>
              </Spin>
            </PaywallProvider>
          </TagsProvider>
        </DateProvider>
      </SlackChannelsProvider>
    </DiscordChannelsProvider>
  );
};

export default Home;
